import { render, staticRenderFns } from "./rangliste_table.vue?vue&type=template&id=277b2742&scoped=true"
import script from "./rangliste_table.vue?vue&type=script&lang=js"
export * from "./rangliste_table.vue?vue&type=script&lang=js"
import style0 from "./rangliste_table.vue?vue&type=style&index=0&id=277b2742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277b2742",
  null
  
)

export default component.exports